<div class="container">

  <div class="portalCard">
    <div class="aTitle">
      <mat-icon>chat</mat-icon>
      <span>Bestandsauskunft</span>
    </div>
    <vermittlerportal-app></vermittlerportal-app>

  </div>
</div>

